// Specialist Referrals Module
// Manages patient referrals to medical specialists

import SpecialistReferralsPage from "./pages/SpecialistReferralsPage";
import ReferralCreatePage from "./pages/ReferralCreatePage";

// Export routes for AppRouter
export const specialistReferralsRoutes = [
  {
    path: "/specialist-referrals",
    element: <SpecialistReferralsPage />,
  },
  {
    path: "/specialist-referrals/create",
    element: <ReferralCreatePage />,
  },
  {
    path: "/specialist-referrals/edit/:referralId",
    element: <ReferralCreatePage />,
  },
];

// Export components for external use
export { default as SpecialistReferralsPage } from "./pages/SpecialistReferralsPage";
export { default as ReferralCreatePage } from "./pages/ReferralCreatePage";
export { default as ReferralsTable } from "./components/ReferralsTable";

// Export utilities
export * from "./constants/referralOptions";
export * from "./services";
